import {
    AgentExtensionReportActions,
    AgentExtensionReportFilter,
    AgentExtensionReportGetters,
    AgentExtensionReportMutations,
    AgentExtensionReportState,
    FilterItem,
    SortMenuItem,
} from '@/types';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const getDefaultState = () => {
    return {
        filter: {
            status: null,
            user: null,
            userLabel: null,
            queue: null,
        },
        page: 1,
        search: null,
        sort: [],
    } as AgentExtensionReportState;
};

const state: AgentExtensionReportState = getDefaultState();

const mutations: MutationTree<AgentExtensionReportState> = {
    [AgentExtensionReportMutations.SET_SEARCH]: (state, search: string) => (state.search = search),
    [AgentExtensionReportMutations.SET_SORT]: (state, sort: SortMenuItem[]) => (state.sort = sort),
    [AgentExtensionReportMutations.SET_FILTER](state, filter: AgentExtensionReportFilter) {
        state.filter.status = filter.status;
        state.filter.user = filter.user;
        state.filter.userLabel = filter.userLabel;
        state.filter.queue = filter.queue;
    },
    [AgentExtensionReportMutations.CLEAR_FILTER](state, field?: string) {
        switch (field) {
            case 'status':
                state.filter.status = null;
                break;
            case 'user':
                state.filter.user = null;
                break;
            case 'userLabel':
                state.filter.userLabel = null;
                break;
            case 'queue':
                state.filter.queue = null;
                break;
            default:
                state.filter.status = null;
                state.filter.user = null;
                state.filter.userLabel = null;
                state.filter.queue = null;
        }
    },
};

const actions: ActionTree<AgentExtensionReportState, any> = {
    [AgentExtensionReportActions.SET_SEARCH]: ({ commit }, search: string) =>
        commit(AgentExtensionReportMutations.SET_SEARCH, search),
    [AgentExtensionReportActions.SET_SORT]: ({ commit }, sort: SortMenuItem[]) =>
        commit(AgentExtensionReportMutations.SET_SORT, sort),
    [AgentExtensionReportActions.SET_FILTER]: ({ commit }, filter: AgentExtensionReportFilter) =>
        commit(AgentExtensionReportMutations.SET_FILTER, filter),
    [AgentExtensionReportActions.CLEAR_FILTER]: ({ commit }, filter: AgentExtensionReportFilter) =>
        commit(AgentExtensionReportMutations.CLEAR_FILTER, filter),
};

const getters: GetterTree<AgentExtensionReportState, any> = {
    [AgentExtensionReportGetters.SEARCH]: (state): string | null => state.search,
    [AgentExtensionReportGetters.SORT]: (state): SortMenuItem[] => state.sort,
    [AgentExtensionReportGetters.DEFAULT_FILTER]: (): AgentExtensionReportFilter =>
        getDefaultState().filter,
    [AgentExtensionReportGetters.FILTER]: (state): AgentExtensionReportFilter => state.filter,
    [AgentExtensionReportGetters.ACTIVE_FILTERS](state): FilterItem[] {
        const filters: Array<FilterItem> = [];

        if (state.filter.status) {
            filters.push({
                field: 'status',
                label: state.filter.status.label,
                value: state.filter.status.value,
            });
        }

        if (state.filter.user) {
            filters.push({
                field: 'user',
                label: state.filter.user.name,
                value: state.filter.user.id,
            });
        }

        if (state.filter.userLabel) {
            filters.push({
                field: 'userLabel',
                label: state.filter.userLabel.label,
                value: state.filter.userLabel.id,
            });
        }

        if (state.filter.queue) {
            filters.push({
                field: 'queue',
                label: state.filter.queue.name,
                value: state.filter.queue.id,
            });
        }

        return filters;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};
